import { Switch, Route, Redirect } from "react-router-dom";
import LeaderboardRanking from "./LeaderboardRanking";
import { RampLeftRail, RampRightRail } from "components/Ads/RampRails";
import MediaQuery from "components/MediaQuery";

export function LeaderboardsPage() {
  return (
    <div className="flex justify-center mx-auto w-full max-md:w-full">
      <MediaQuery min="DESKTOP_SMALL" max="DESKTOP_LARGE" renderNullOnFail isClient>
        <div className="flex-1 min-w-0 mr-[-12px]">
          <RampLeftRail className="sticky top-[calc(var(--masthead-height)+var(--game-nav-height)+24px)]" />
        </div>
      </MediaQuery>
      <div className="leaderboards-page">
        <div className="content-side-padding leaderboards_content-container">
          <Switch>
            <Route path="/leaderboards/ranking" component={LeaderboardRanking} />
            <Redirect to="/leaderboards/ranking" />
          </Switch>
        </div>
      </div>
      <MediaQuery min="DESKTOP_SMALL" max="DESKTOP_LARGE" renderNullOnFail isClient>
        <div className="flex-1 min-w-0 ml-[-12px]">
          <RampRightRail className="sticky top-[calc(var(--masthead-height)+var(--game-nav-height)+24px)]" />
        </div>
      </MediaQuery>
    </div>
  );
}
